import { createAsyncReducer, createDefaultInitialState, createReducerFromMap } from "@coverme/redux";

const initialState = {
    isLoading: false,
    isInitialized: false,
    data: [],
};

const getNotifications = (state, data) => {
    return {
        ...state,
        data: data.value,
    };
};
export const notificationsReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_NOTIFICATIONS", getNotifications),
});
